import { useState } from 'react';
import FormData from 'form-data';
import history from '../../helpers/history';
import { useDispatch } from 'react-redux';
import useResetError from '../useResetError';
import { USER_KEY } from '../../helpers/constants';
import { handleApiError } from '../../helpers';
import { completeProfile } from '../../states/action_creators';
import { completeBorrowerProfileApi } from '../../apis/borrower';
import { AuthenthicatedUserInfo, BorrowerDto, BorrowerProfileFormValues } from '../../interfaces';

const useSubmitBorrowerProfile = () => {
  const [submitting, setSubmitting] = useState<boolean>(false);
  const { error, setError } = useResetError();
  const formData = new FormData();
  const dispatch = useDispatch();

  const createMultiPartFormData = (payload: BorrowerDto) => {
    for (const [key, value] of Object.entries(payload)) {
      // check for image fields
      if (key === 'income_prove' || key === 'work_prove') {
        if (value) {
          formData.append(key, value.item(0));
        }
      } else if (typeof value === 'object') {
        formData.append(key, JSON.stringify(value));
      } else if (typeof value === 'undefined') {
        formData.append(key, '');
      } else {
        formData.append(key, value);
      }
    }
    return formData;
  };

  const onSubmitHandler = async (payload: BorrowerDto) => {
    setSubmitting(true);
    setError(null);

    try {
      const data = createMultiPartFormData(payload);
      const user: AuthenthicatedUserInfo = JSON.parse(localStorage.getItem(USER_KEY)!);
      const headers = {
        'Content-type': 'multipart/form-data',
      };

      await completeBorrowerProfileApi(data, headers);
      setSubmitting(false);

      const updatedUser = { ...user, profileCompleted: true };
      dispatch(completeProfile(updatedUser));
      history.push('/dashboard');
    } catch (error) {
      setSubmitting(false);
      setError(handleApiError(error));
    }
  };

  const onSubmit = (values: BorrowerProfileFormValues) => {
    const payload: BorrowerDto = {
      location: { address: values.address!, city: values.city!, country_id: +values.country!, state_id: +values.state! },
      occupation: values.occupation,
      is_self_employed: values.employment_status === 'self',
      income_prove: values.income_prove,
      work_prove: values.work_prove,
      linkedin: values.linkedin,
      bvn: values.bvn,
      nin: values.nin,
    };

    if (values.employment_status === 'self') {
      payload.business = {
        name: values.business_name!,
        location: {
          city: values.business_city!,
          state_id: +values.business_state!,
          country_id: +values.business_country!,
        },
        rc_no: values.rc_no!,
        business_type: values.business_type!,
        job_title: values.job_title!,
        duration: +values.business_duration!,
      };
    } else {
      payload.employer = {
        name: values.employer_name!,
        location: {
          city: values.employer_city!,
          state_id: +values.employer_state!,
          country_id: +values.employer_country!,
        },
        job_title: values.job_title!,
        duration: +values.employment_duration!,
      };
    }
    onSubmitHandler(payload);
  };
  return { onSubmit, submitting, error };
};

export default useSubmitBorrowerProfile;
